import script from "./TalentCards.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentCards.vue?vue&type=script&setup=true&lang=js"

import "./TalentCards.vue?vue&type=style&index=0&id=e4f334ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4f334ca"]])

export default __exports__